module.exports = __webpack_public_path__ + "static/media/groomingBanner1.83d55877.png";